import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../static/icons/info.svg'


const _hoisted_1 = { class: "decoration-technique" }
const _hoisted_2 = { class: "decoration-technique__title" }
const _hoisted_3 = { class: "decoration-technique__container" }
const _hoisted_4 = {
  key: 0,
  class: "decoration-technique__warning"
}

import { ref, computed, inject, onMounted } from 'vue';

import { injectionKeys as litiumKeys } from '@motillo/drapejs-litium';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import DecorationCard from './DecorationCard.vue';
import DecorationTechniqueVariants from './DecorationTechniqueVariants.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DecorationTechnique',
  props: {
  variants: {
    type: Array,
    required: true
  },
  techniques: {
    type: Array,
    required: true
  },
  selected: {
    type: String,
    default: ''
  },
  selectedVariant: {
    type: String,
    default: ''
  },
  selectedColors: {
    type: Object
  },
  selectedWidth: {
    type: Number,
    default: 0
  },
  selectedHeight: {
    type: Number,
    default: 0
  }
},
  emits: [
  'selected',
  'selectedVariant',
  'desiredWidthUpdated',
  'desiredHeightUpdated'
],
  setup(__props, { emit: __emit }) {

const { websiteText } = useWebsiteTexts();
const emit = __emit;
const toLitiumMediaUrl = inject(litiumKeys.toLitiumMediaUrlKey, () => '');
const startAnimation = ref(false);

const props = __props;

const mappedTechniques = computed(() => {
  return props.techniques.map((t) => {
    return {
      id: t.systemId,
      name: t.name || t.code,
      value: t.code,
      url: toLitiumMediaUrl(t.imageSystemId),
      techniqueTypeCode: t.techniqueTypeCode,
      landingPageLinkUrl: t.landingPageLinkUrl
    };
  });
});

const selectedTechnique = ref(props.selected);

const variants = computed(() => {
  return (
    props.techniques.find((t) => t.systemId === selectedTechnique.value)
      ?.variants || []
  );
});

const singleVariant = computed(() => {
  return variants.value.length === 1;
});

function hasCombinedVariants(technique) {
  return false && technique.techniqueTypeCode === 'PU LABEL';
}

function selectTechnique(id: string) {
  startAnimation.value = false;
  selectedTechnique.value = id;
  emit('selected', id);

  const selectedTechniqueObject = props.techniques.find(
    (t) => t.systemId == id
  );
  if (selectedTechniqueObject.techniqueTypeCode === 'PU LABEL') {
    for (var i = 0; i < variants.value.length; i++) {
      selectVariant(variants.value[i].systemId);
    }
  } else {
    selectVariant(variants.value[0].systemId);
  }

  setTimeout(() => {
    startAnimation.value = true;
  }, 0);
}

function selectVariant(id: string, colors = undefined) {
  const variant = variants.value.find((v) => v.systemId === id);
  const variantData = {
    brackets: variant.prices,
    id,
    addons: variant.addons
      .filter((a) => a.mandatory)
      .map((a) => {
        return {
          VariantSystemId: a.systemId,
          Quantity: 1,
          price: a.price,
          name: a.name,
          OnlyOnePerProductGroup: a.mandatory
        };
      }),
    supportedVariants: variant.supportedVariants
  };

  if (colors) {
    variantData.colors = colors;
  }

  emit('selectedVariant', variantData);
}

function desiredWidthUpdated(value: number) {
  emit('desiredWidthUpdated', value);
}

function desiredHeightUpdated(value: number) {
  emit('desiredHeightUpdated', value);
}

function techniqueOrder(idx) {
  const oneIndexed = idx + 1;
  return oneIndexed + Math.floor((oneIndexed - 1) / 2);
}

function variantOrder(idx) {
  const oneIndexed = idx + 1;
  return Math.ceil(oneIndexed / 2) * 3;
}

onMounted(() => {
  if (selectedTechnique.value && !singleVariant.value) {
    startAnimation.value = true;
  }
});

const notAvailableText = computed(() => {
  if (!singleVariant.value) {
    return '';
  }

  const selectedTechniqueVariant = variants.value[0];
  let notAvailableVariants = [];

  for (var i = 0; i < props.variants.length; i++) {
    const prodVariant = props.variants[i];
    if (
      selectedTechniqueVariant.supportedVariants.filter(
        (v) => v == prodVariant.systemId
      ).length == 0
    ) {
      notAvailableVariants.push(prodVariant.fields?.Color?.[0]?.name || '');
    }
  }

  if (notAvailableVariants.length == 0) {
    return '';
  }

  const notAvailableVariantsText = notAvailableVariants.join(', ');
  return websiteText('decoration__not_available', {
    decoration: selectedTechniqueVariant.name,
    variant: notAvailableVariantsText
  }).value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(websiteText)('decoration__choose_technique').value), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappedTechniques.value, (technique, idx) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: technique.id
        }, [
          _createVNode(DecorationCard, {
            decoration: technique,
            selected: technique.id === selectedTechnique.value,
            onSelected: selectTechnique,
            style: _normalizeStyle({ order: techniqueOrder(idx) })
          }, null, 8, ["decoration", "selected", "style"]),
          _createElementVNode("div", {
            class: "decoration-technique__decoration-variants-wrapper",
            style: _normalizeStyle({ order: variantOrder(idx) })
          }, [
            (
              selectedTechnique.value === technique.id &&
              !singleVariant.value &&
              !hasCombinedVariants(technique)
            )
              ? (_openBlock(), _createBlock(DecorationTechniqueVariants, {
                  key: 0,
                  class: _normalizeClass([
              'decoration-technique__decoration-variants',
              {
                'decoration-technique__decoration-variants--active':
                  startAnimation.value
              }
            ]),
                  productVariants: props.variants,
                  variants: variants.value,
                  selected: __props.selectedVariant,
                  colors: __props.selectedColors,
                  "desired-width": __props.selectedWidth,
                  "desired-height": __props.selectedHeight,
                  onSelected: selectVariant,
                  onDesiredWidthUpdated: desiredWidthUpdated,
                  onDesiredHeightUpdated: desiredHeightUpdated
                }, null, 8, ["class", "productVariants", "variants", "selected", "colors", "desired-width", "desired-height"]))
              : _createCommentVNode("", true)
          ], 4)
        ], 64))
      }), 128))
    ]),
    (notAvailableText.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            class: "decoration-technique__warning_icon",
            src: _imports_0
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(notAvailableText.value), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})